import { render, staticRenderFns } from "./InvalidatePasswordForm.vue?vue&type=template&id=2ff3be48"
import script from "./InvalidatePasswordForm.vue?vue&type=script&lang=js"
export * from "./InvalidatePasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports